import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'

export default function UserMenu() {
  const { user, profile, signInWithGoogle, signOut, isLoading } = useAuth()
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()

  if (isLoading) {
    return (
      <div className="w-10 h-10 rounded-full bg-alvinegro-light animate-pulse" />
    )
  }

  if (!user) {
    return (
      <button
        onClick={signInWithGoogle}
        className="flex items-center gap-2 bg-white text-alvinegro-black px-4 py-2 rounded-full text-sm font-medium hover:bg-alvinegro-light transition-colors whitespace-nowrap cursor-pointer shadow-sm"
      >
        <i className="ri-google-fill text-base"></i>
        Entrar
      </button>
    )
  }

  return (
    <div className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 rounded-full bg-white/90 hover:bg-white px-3 py-1.5 transition-colors cursor-pointer shadow-sm"
      >
        {profile?.avatar ? (
          <img
            src={profile.avatar}
            alt={profile.name || 'Usuário'}
            className="w-8 h-8 rounded-full object-cover"
          />
        ) : (
          <div className="w-8 h-8 rounded-full bg-alvinegro-black flex items-center justify-center">
            <i className="ri-user-line text-white text-sm"></i>
          </div>
        )}
        <span className="text-sm font-medium text-alvinegro-dark max-w-[100px] truncate hidden sm:block">
          {profile?.name || 'Usuário'}
        </span>
        <i className="ri-arrow-down-s-line text-alvinegro-dark text-sm"></i>
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 mt-2 w-56 bg-white rounded-xl shadow-xl border border-alvinegro-border z-50 py-2">
            <div className="px-4 py-3 border-b border-alvinegro-border">
              <p className="text-sm font-semibold text-alvinegro-black">{profile?.name || 'Usuário'}</p>
              <p className="text-xs text-alvinegro-muted truncate">{user.email}</p>
              {profile?.role !== 'user' && (
                <span className="inline-block mt-1 px-2 py-0.5 bg-alvinegro-black text-white text-xs rounded-full">
                  {profile?.role === 'admin' ? 'Admin' : 'Moderador'}
                </span>
              )}
            </div>
            <div className="py-1">
              <button
                onClick={() => { setOpen(false) }}
                className="w-full text-left px-4 py-2 text-sm text-alvinegro-dark hover:bg-alvinegro-light transition-colors cursor-pointer"
              >
                <i className="ri-user-line mr-2"></i>
                Meu Perfil
              </button>
              {profile?.role === 'admin' && (
                <button
                  onClick={() => { navigate('/admin'); setOpen(false) }}
                  className="w-full text-left px-4 py-2 text-sm text-alvinegro-dark hover:bg-alvinegro-light transition-colors cursor-pointer"
                >
                  <i className="ri-dashboard-line mr-2"></i>
                  Painel Admin
                </button>
              )}
              {(profile?.role === 'admin' || profile?.role === 'moderator') && (
                <button
                  onClick={() => { navigate('/moderacao'); setOpen(false) }}
                  className="w-full text-left px-4 py-2 text-sm text-alvinegro-dark hover:bg-alvinegro-light transition-colors cursor-pointer"
                >
                  <i className="ri-shield-check-line mr-2"></i>
                  Moderação
                </button>
              )}
              <button
                onClick={() => { signOut(); setOpen(false) }}
                className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors cursor-pointer"
              >
                <i className="ri-logout-box-line mr-2"></i>
                Sair
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  )
}